import styled from 'styled-components'
import { Modal } from 'antd'

export const MyModal = styled(Modal)<{
  dark?: boolean
  hiddenBorderTop?: boolean
}>`
  .ant-modal-content {
    background: ${props =>
      props.dark ? props.theme.dark1 : props.theme.light3};
  }
  .ant-modal-header {
    border-radius: 20px 20px 0 0;
    padding: 32px 32px 0 32px;
    border: none;
    background: ${props =>
      props.dark ? props.theme.dark1 : props.theme.light3};
  }
  .ant-modal-title {
    color: ${props => (props.dark ? props.theme.light3 : props.theme.dark2)};
    font-size: 32px;
    line-height: 40px;
  }
  .ant-modal-close {
    top: 32px;
    right: 32px;
    transition: all 0.3;
    &:hover {
      .ant-modal-close-icon {
        color: ${props =>
          props.dark ? props.theme.light3 : props.theme.dark2};
        border-color: ${props =>
          props.dark ? props.theme.light3 : props.theme.dark2};
      }
    }
  }
  .ant-modal-close-x {
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
  .ant-modal-close-icon {
    border: 2px solid
      ${props => (props.dark ? props.theme.dark5 : props.theme.light1)};
    border-radius: 48px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    color: ${props => (props.dark ? props.theme.dark5 : props.theme.dark2)};
  }
  .ant-modal-body {
    padding: 32px;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.primaryColor};
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${props => props.theme.light1};
      border-radius: 4px;
    }
  }
  .ant-modal-content {
    border-radius: 20px;
  }
  .ant-form-item-extra {
    margin-top: 12px;
  }
  .ant-modal-footer {
    border-top: 1px solid
      ${props => (!props.hiddenBorderTop ? '#f0f0f0' : 'transparent')};
  }
`
